module.exports = __webpack_public_path__ + "static/img/xi_13.c9052ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_13.jpg
// module id = Y5uz
// module chunks = 1